import {
  useIsMapsClient,
  useIsMapsRegionalMimicClient,
  useMapsAgentMimicClient
} from 'store/features/auth';

export const useShowFavouriteStations = () => {
  const isMapsClient = useIsMapsClient();
  const isMapsRegionalMimicClient = useIsMapsRegionalMimicClient();
  const isMapsAgentMimicClient = useMapsAgentMimicClient();

  return isMapsClient || isMapsRegionalMimicClient || isMapsAgentMimicClient;
};
